export default {"src":"/_next/static/media/5.f8fca554.svg","height":79,"width":56,"blurWidth":0,"blurHeight":0};